import { DeviceModelPortAllocationOutputWithStatus } from './device-model-port-allocation-output-with-status.model';


export class DeviceModelPortAllocationSelectByIdOutput implements IDeviceModelPortAllocationSelectByIdOutput {
    status!: number;
    message!: string;
    data!: DeviceModelPortAllocationOutputWithStatus;

    constructor(data?: IDeviceModelPortAllocationSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? DeviceModelPortAllocationOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceModelPortAllocationSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceModelPortAllocationSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDeviceModelPortAllocationSelectByIdOutput {
    status: number;
    message: string;
    data: DeviceModelPortAllocationOutputWithStatus;
}

